















import { Component, Prop, Vue } from "vue-property-decorator";
import { getIgdStatusMeta, IgdStatusMeta } from "@/constants/igdStatus";

interface IgdIndicator {
  status?: string | null;
  status_label?: string | null;
}

@Component({})
export default class IgdStatusChip extends Vue {
  @Prop({ default: null }) readonly indicator!: IgdIndicator | null;

  get cfg(): IgdStatusMeta | null {
    return getIgdStatusMeta(this.indicator ? this.indicator.status : null);
  }

  /** Status tak dikenal (backend menambah status baru): pakai label dari API. */
  get fallbackLabel(): string | null {
    return this.indicator ? this.indicator.status_label || null : null;
  }
}
